import BaseNavbar from "./shared/BaseNavbar";
import BrandLogo from "./shared/BrandLogo";
import MobileMenuTrigger from "./shared/MobileMenuTrigger";
import NavbarLink from "./shared/NavbarLink";
import Dropdown from "../auxiliar/ui/Dropdown";
import useQueryParams from "../../../auxiliar/customHooks/useQueryParams";
import { getDynamicLink } from "../../../auxiliar/auxFunctions";

const NavbarReservation = () => {
    const params = useQueryParams();

    const getItems = () => {
        const items = [
            { to: getDynamicLink("/reservation", "agenda", params), label: "Agenda", position: 0 },
            { to: getDynamicLink("/reservation", "clinic", params), label: "Clínica", position: 2 },
            {
                to: getDynamicLink("/reservation", "info", params),
                label: "Información",
                position: 3,
            },
            { to: "/login", label: "Soy un Fisio", position: 4 },
        ];

        if (params.has("session")) {
            items.push({
                to: getDynamicLink("/reservation", "session", params),
                label: "Reserva",
                position: 1,
            });
        }

        return items;
    };

    const startContent = (
        <>
            <Dropdown trigger={<MobileMenuTrigger />} items={getItems()} className="xl:hidden" />
            <BrandLogo to={getDynamicLink("/reservation", "agenda", params)} size="desktop" />
        </>
    );

    const centerContent = (
        <>
            <div className="px-1 hidden xl:flex gap-1 items-center">
                {getItems()
                    .sort((a, b) => a.position - b.position)
                    .map((link) => (
                        <NavbarLink key={link.to} to={link.to}>
                            {link.label}
                        </NavbarLink>
                    ))}
            </div>
            <BrandLogo to={getDynamicLink("/reservation", "agenda", params)} size="mobile" />
        </>
    );

    return <BaseNavbar startContent={startContent} centerContent={centerContent} />;
};

export default NavbarReservation;
